import React from "react";
import { Table } from "reactstrap";
import MonitoringQueueTableDropdown from "./dropdown";

import { array } from "prop-types";
import "./monitoringQueueEntriesTable.css";

import MonitoringQueueEntriesTableRow from "./row";
import { useSelector } from "react-redux";
import {
  selectDeselectedEntries,
  selectSelectedEntries,
} from "../../../../selectors";

const MonitoringQueueEntriesTable = ({
  monitoringQueueEntries,
  selectEntry,
  checkBoxChangeSelection,
  dropdownitemchange,
  organizationInfo,
}) => {
  const selectedEntries = useSelector(selectSelectedEntries);
  const deselectedEntries = useSelector(selectDeselectedEntries);

  const rows = monitoringQueueEntries.map((entry) => (
    <MonitoringQueueEntriesTableRow
      key={entry.id}
      entry={entry}
      selectEntry={selectEntry}
      selectedEntries={selectedEntries}
      deselectedEntries={deselectedEntries}
      organizationInfo={organizationInfo}
    />
  ));

  return (
    <div className="table-overflow-container">
      <Table
        style={{ position: "relative", maxHeight: 500 }}
        className="monitoring-queue-entries-table"
      >
        <thead className="thead-light">
          <tr>
            <th></th> {/* empty */}
            <th>
              <MonitoringQueueTableDropdown
                checkBoxChangeSelection={checkBoxChangeSelection}
                dropdownitemchange={dropdownitemchange}
              />
            </th>
            <th>Type of check</th>
            <th>Date of check</th>
            <th>Type of Client</th>
            <th>Full name</th>
            <th>EGN / Company number</th>
            <th>OfferId</th>
            <th>Risk criteria name</th>
            <th>Risk criteria value</th>
            <th>
              {monitoringQueueEntries[0].clientNegativeMediaCheckResult
                ? "Negative media presence"
                : "Watchlist with match / Risk Level"}
            </th>
            <th>Decision/Scoring Status</th>
            {organizationInfo &&
              organizationInfo.additionalOrganizationProperties &&
              organizationInfo.additionalOrganizationProperties.map(
                (element) => {
                  return <th>{element.name}</th>;
                }
              )}
            <th>Actions</th>
            <th></th> {/* empty */}
          </tr>
        </thead>
        <tbody className="monitoring-queue-tbody mt-5">{rows}</tbody>
      </Table>
    </div>
  );
};

MonitoringQueueEntriesTable.propTypes = {
  monitoringQueueEntries: array.isRequired,
};

export default MonitoringQueueEntriesTable;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-form/table/MonitoringQueueEntriesTable.jsx